exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-content[data-v-9c9cc1c4] {\n  min-height: calc(100vh - 20px);\n}\n.payload-pre[data-v-9c9cc1c4] {\n  background: #0b1220;\n  color: #e5e7eb;\n  padding: 12px;\n  border-radius: 8px;\n  max-height: 320px;\n  overflow: auto;\n  font-size: 12px;\n  line-height: 1.4;\n}", ""]);

// exports
